<template>
	<el-row>
		<el-row>
			<el-input placeholder="请输入会员id" style="width: 200px;margin-right: 10px;" v-model="personId" />
			<el-input placeholder="请输入会员昵称" style="width: 200px;margin-right: 10px;" v-model="userName" />
			<el-button @click="demand" type="primary">筛选</el-button>
			<el-button @click="Export">导出excel</el-button>
			<el-button @click="zhikong">置空</el-button>
		</el-row>
		<el-table :data="tableData">
			<el-table-column label="序号" prop='id'></el-table-column>
			<el-table-column label="头像">
				<template slot-scope="scope">
					<el-image :src="scope.row.wxIcon" style="width: 100px;height: 100px;"></el-image>
				</template>
			</el-table-column>
			<el-table-column label="昵称" prop="userName"></el-table-column>
			<el-table-column label="用户id" prop="personId"></el-table-column>
			<el-table-column label="用户等级" prop="levelName"></el-table-column>
			<el-table-column label="执行天数" prop="executionDays"></el-table-column>
			<el-table-column label="参与时间" prop="createTime"></el-table-column>
		</el-table>
		<div style="margin: 20px 30%;">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30,50,100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				personId: "",
				userName: "",
				pageNum: 1,
				pageSize: 30,
				total: 0,
				tableData: [],
			}
		},
		methods: {
			zhikong() {
				this.personId = ""
				this.userName = ""
				this.pageNum = 1
				this.getInfo()
			},
			//查询
			demand() {
				this.getInfo()
			},
			//导出
			Export() {
				this.$http.post('/api/statistics/knowledgeBase/exportJoinScenarioData', {
					"personId": this.personId, //人员ID
					"userName": this.userName,
					"scenarioId": this.$route.query.id
				}, {
					responseType: 'blob'
				}).then(res => {
					this.$message({
						type: 'info',
						message: '正在导出表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '训练人员列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			//查询列表
			getInfo() {
				this.$http.post('/api/plant/positions/selectJoinScenarioData', {
					"personId": this.personId,
					"userName": this.userName,
					"scenarioId": this.$route.query.id,
					"pageNum": this.pageNum,
					"pageSize": this.pageSize
				}).then(res => {
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			},
			//条数发生变化
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getInfo()
			},
			//页数
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style>
</style>